import SuggestRelatedFunds from './suggestRelatedFunds';
import SectionHeader from '../plan/sectionHeader';
import Modal from '../modal';

const SuggestedFundModal = (props: any) => (
  <Modal
    fullScreen
    headerPad={15}
    title="Unable to Invest"
    onDismiss={props.dismissModal}
  >
    <div className="row ml0 mr0 pt10 pb30">
      <div className="columns">
        Currently this fund is not available on ClearTax Invest. We request you
        to checkout other related funds below
      </div>
      <div className="columns">
        <SectionHeader title="Related Funds" />
      </div>
      <div className="columns">
        <SuggestRelatedFunds fundLimit={4} isinCode={props.isinCode} />
      </div>
    </div>
  </Modal>
);

export default SuggestedFundModal;



// WEBPACK FOOTER //
// ./components/common/suggestedFundModal.tsx